import { OnHoverTooltip } from '../../common/OnHoverTooltip';

export const NotApplicable = () => {
    return <OnHoverTooltip overlay="Not Applicable">N/A</OnHoverTooltip>;
};
